var map = {
	"./de/AirElemental.jpg": "366d",
	"./de/Angel.jpg": "ab41",
	"./de/Basilisk.jpg": "4e43",
	"./de/Beastmaster.jpg": "3120",
	"./de/BellTower.jpg": "6a16",
	"./de/BellTowerCH.jpg": "a451",
	"./de/Blizzard.jpg": "71d2",
	"./de/BookOfChanges.jpg": "2715",
	"./de/Candle.jpg": "ab31",
	"./de/Castle.jpg": "68bd",
	"./de/Cavern.jpg": "ecbe",
	"./de/Chapel.jpg": "c1e0",
	"./de/Collector.jpg": "3cb0",
	"./de/Crypt.jpg": "08ba",
	"./de/DarkQueen.jpg": "60b8",
	"./de/DeathKnight.jpg": "f660",
	"./de/Demon.jpg": "46ba",
	"./de/Doppelgaenger.jpg": "5c9f",
	"./de/Dragon.jpg": "c382",
	"./de/Dungeon.jpg": "fcfd",
	"./de/DwarvishInfantry.jpg": "1a89",
	"./de/EarthElemental.jpg": "b0ea",
	"./de/ElvenArchers.jpg": "840c",
	"./de/ElvenLongbow.jpg": "94fa",
	"./de/Empress.jpg": "cee9",
	"./de/Enchantress.jpg": "b8af",
	"./de/FireElemental.jpg": "64c3",
	"./de/Forest.jpg": "4471",
	"./de/Forge.jpg": "fe41",
	"./de/FountainOfLife.jpg": "59a5",
	"./de/FountainOfLifeCH.jpg": "a613",
	"./de/Garden.jpg": "3350",
	"./de/GemOfOrder.jpg": "225b",
	"./de/Genie.jpg": "2074",
	"./de/Ghoul.jpg": "6490",
	"./de/GreatFlood.jpg": "140f",
	"./de/GreatFloodCH.jpg": "22a1",
	"./de/Hydra.jpg": "6279",
	"./de/Island.jpg": "f538",
	"./de/Jester.jpg": "e572",
	"./de/Judge.jpg": "dab9",
	"./de/King.jpg": "6c4a",
	"./de/Knights.jpg": "4b44",
	"./de/Leprechaun.jpg": "6d22",
	"./de/Lich.jpg": "cd58",
	"./de/LightCavalry.jpg": "a8a2",
	"./de/Lightning.jpg": "36a5",
	"./de/MagicWand.jpg": "86ab",
	"./de/Mirage.jpg": "81cf",
	"./de/MirageCH.jpg": "7a00",
	"./de/Mountain.jpg": "fc44",
	"./de/Necromancer.jpg": "da9b",
	"./de/NecromancerCH.jpg": "9ac3",
	"./de/Princess.jpg": "1ab3",
	"./de/ProtectionRune.jpg": "37f9",
	"./de/Queen.jpg": "f10e",
	"./de/Rainstorm.jpg": "482b",
	"./de/Rangers.jpg": "704f",
	"./de/RangersCH.jpg": "fcd6",
	"./de/Shapeshifter.jpg": "ab0e",
	"./de/ShapeshifterCH.jpg": "e240",
	"./de/ShieldOfKeth.jpg": "5029",
	"./de/Smoke.jpg": "0bc5",
	"./de/Specter.jpg": "3293",
	"./de/Swamp.jpg": "baec",
	"./de/SwordOfKeth.jpg": "142a",
	"./de/Unicorn.jpg": "e215",
	"./de/WarDirigible.jpg": "fa72",
	"./de/Warhorse.jpg": "6c46",
	"./de/WarlockLord.jpg": "6245",
	"./de/Warlord.jpg": "3768",
	"./de/Warship.jpg": "8cb9",
	"./de/WaterElemental.jpg": "3e26",
	"./de/Whirlwind.jpg": "9df6",
	"./de/Wildfire.jpg": "ff3b",
	"./de/WorldTree.jpg": "eec3",
	"./de/WorldTreeCH.jpg": "f875",
	"./de/back.jpg": "5f26",
	"./en/AirElemental.jpg": "42846",
	"./en/Angel.jpg": "d484",
	"./en/Basilisk.jpg": "a355",
	"./en/Beastmaster.jpg": "9d6e",
	"./en/BellTower.jpg": "c7ec",
	"./en/BellTowerCH.jpg": "4fd1",
	"./en/Blizzard.jpg": "e21f",
	"./en/BookOfChanges.jpg": "2601",
	"./en/Candle.jpg": "43ed",
	"./en/Castle.jpg": "5081",
	"./en/Cavern.jpg": "21ed",
	"./en/Chapel.jpg": "655e",
	"./en/Collector.jpg": "4693",
	"./en/Crypt.jpg": "5ee0",
	"./en/DarkQueen.jpg": "7707",
	"./en/DeathKnight.jpg": "d38b",
	"./en/Demon.jpg": "1c1b",
	"./en/Doppelgaenger.jpg": "e70c",
	"./en/Dragon.jpg": "acdd",
	"./en/Dungeon.jpg": "6f7c",
	"./en/DwarvishInfantry.jpg": "0f06",
	"./en/EarthElemental.jpg": "b33e",
	"./en/ElvenArchers.jpg": "bcd5",
	"./en/ElvenLongbow.jpg": "d1fd",
	"./en/Empress.jpg": "9ce5",
	"./en/Enchantress.jpg": "c94f",
	"./en/FireElemental.jpg": "567a",
	"./en/Forest.jpg": "67d1",
	"./en/Forge.jpg": "77b5",
	"./en/FountainOfLife.jpg": "7f32",
	"./en/FountainOfLifeCH.jpg": "396c",
	"./en/Garden.jpg": "f562",
	"./en/GemOfOrder.jpg": "ece7",
	"./en/Genie.jpg": "e229",
	"./en/Ghoul.jpg": "71bd",
	"./en/GreatFlood.jpg": "cea7",
	"./en/GreatFloodCH.jpg": "7f6d",
	"./en/Hydra.jpg": "ada5",
	"./en/Island.jpg": "a643",
	"./en/Jester.jpg": "f622",
	"./en/Judge.jpg": "daa8",
	"./en/King.jpg": "43c6",
	"./en/Knights.jpg": "577c",
	"./en/Leprechaun.jpg": "2ce8",
	"./en/Lich.jpg": "095c",
	"./en/LightCavalry.jpg": "67f9",
	"./en/Lightning.jpg": "a284",
	"./en/MagicWand.jpg": "85b1",
	"./en/Mirage.jpg": "455c",
	"./en/MirageCH.jpg": "805c",
	"./en/Mountain.jpg": "0910",
	"./en/Necromancer.jpg": "7b5a",
	"./en/NecromancerCH.jpg": "d880",
	"./en/Princess.jpg": "ea92",
	"./en/ProtectionRune.jpg": "78a5",
	"./en/Queen.jpg": "5582",
	"./en/Rainstorm.jpg": "3bba",
	"./en/Rangers.jpg": "0203",
	"./en/RangersCH.jpg": "ab9a",
	"./en/Shapeshifter.jpg": "0c8b",
	"./en/ShapeshifterCH.jpg": "ffb8",
	"./en/ShieldOfKeth.jpg": "9734",
	"./en/Smoke.jpg": "a314",
	"./en/Specter.jpg": "8917",
	"./en/Swamp.jpg": "51c8",
	"./en/SwordOfKeth.jpg": "7ac7",
	"./en/Unicorn.jpg": "9b31",
	"./en/WarDirigible.jpg": "8603",
	"./en/Warhorse.jpg": "ff55",
	"./en/WarlockLord.jpg": "a67e",
	"./en/Warlord.jpg": "be7f",
	"./en/Warship.jpg": "18e7",
	"./en/WaterElemental.jpg": "412f",
	"./en/Whirlwind.jpg": "ea54",
	"./en/Wildfire.jpg": "0bbe",
	"./en/WorldTree.jpg": "1b47",
	"./en/WorldTreeCH.jpg": "8ecd",
	"./en/front.jpg": "fdc5",
	"./en/lounge.jpg": "8782"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4729";